import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { AppBar, Tabs, Tab, Box } from '@material-ui/core/';
import { useTranslation } from 'react-i18next';
import ProgressMonitor from './automMonitor/ProgressMonitor';
import PendingMonitor from './automMonitor/PendingMonitor';
import HistoryMonitor from './automMonitor/HistoryMonitor';
import ScheduleMonitor from './automMonitor/ScheduleMonitor';
import QueueService from "../../../services/QueueService/QueueService";
import Search from "../../../components/Search/Search";
import { Button, Grid } from "@material-ui/core";
import Filters from '../../../components/DataTable/Filters/Filters';
import CustomizeView from "../../../components/DataTable/CustomizeView/CustomizeView";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import './MonitoringIndex.css';

//override css material ui tabs 
const TabStyle = withStyles((theme) => ({
    root: {
        fontSize: "12px",
        fontWeight: "700",
        textTransform: "none",
        '&:hover': {
            color: 'var(--gravel) !important',
            opacity: 1,
        },
        '&$selected': {
            color: 'var(--black-pearl)',
        },
        minWidth: "180px",
    },
    selected: {},
}))((props) => <Tab {...props} />)

const useStyles = makeStyles(theme => ({
    customTabIndicator: {
        height: "3px",
        backgroundColor: "var(--black-pearl)"
    }
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div hidden={value !== index} {...other}>
            {value === index && (<Box>{children}</Box>)}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
};


function MonitoringIndex(props) {
    const { t } = useTranslation();
    const [value, setValue] = useState(0);
    const [searchData, setSearchData] = useState([])
    const [openCustomizeView, setOpenCustomizeView] = useState(false);
    const [customColumn, setCustomColumn] = useState([])
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchKeyData, setSearchKeyData] = useState("");
    const [openFilters, setOpenFilters] = useState(false);
    const classes = useStyles();

    useEffect(() => {
        //first render
        fetchData('["IN-PROGRESS"]').then(() => true);
    }, [])

    const fetchData = async (val) => {
        setLoading(true);
        let response = await QueueService.getAutomQueueList(val);
        if (response) {
            setData(response.data);
            setSearchData(response.data);
        }

        setLoading(false);
    };


    function handleOpen(open, setState) {
        setState(!open)
    }

    const handleChange = (e, newValue) => {
        setSearchData([]);
        setValue(newValue);

        switch (newValue) {
            case 0:
                fetchData('["IN-PROGRESS"]').then(() => true);
                break;
            case 1:
                fetchData('["PENDING"]').then(() => true);
                break;
            case 2:
                fetchData('["COMPLETED","CANCELED", "FAILED"]').then(() => true);
                break;
            case 3:
                setSearchData([]);
                break;
            default:
                break;
        }
    };

    return (
        <div id="credential-container">
            <Search data={data} setSearchData={setSearchData} searchKey={searchKeyData} xs={11} sm={11} md={11} lg={4}
                xl={4} spacing={2}>
                <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                    <Button className="searchbar-button"
                        onClick={() => handleOpen(openCustomizeView, setOpenCustomizeView)}>{t('CONTENT.DATATABLE.TOOLBAR.CUSTOMIZE-VIEW')}</Button>
                    <Button className="searchbar-button"
                        onClick={() => handleOpen(openFilters, setOpenFilters)}>{t('CONTENT.DATATABLE.TOOLBAR.FILTERS')}</Button>
                </Grid>
            </Search>
            <AppBar id="monitoring-appbar" position="static">
                <Tabs id="monitoring-tabs" value={value} onChange={handleChange}
                    classes={{
                        indicator: classes.customTabIndicator
                    }}
                    textColor="primary">
                    <TabStyle label={t('MESSAGES.MONITORING.IN-PROGRESS')} />
                    <TabStyle label={t('MESSAGES.MONITORING.PENDING')} />
                    <TabStyle label={t('MESSAGES.MONITORING.HISTORY')} />
                    <TabStyle label={t('MESSAGES.MONITORING.SCHEDULE')} />
                </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}><ProgressMonitor loading={loading} setSearchKeyData={setSearchKeyData}
                setSearchData={setSearchData} customColumn={customColumn}
                searchData={searchData} setCustomColumn={setCustomColumn}
                fetchData={fetchData} /></TabPanel>
            <TabPanel value={value} index={1}><PendingMonitor loading={loading} setSearchKeyData={setSearchKeyData}
                setSearchData={setSearchData} customColumn={customColumn}
                searchData={searchData}
                setCustomColumn={setCustomColumn} /></TabPanel>
            <TabPanel value={value} index={2}><HistoryMonitor loading={loading} setLoading={setLoading}
                setSearchKeyData={setSearchKeyData}
                setSearchData={setSearchData} customColumn={customColumn}
                searchData={searchData}
                fetchData={fetchData}
                setCustomColumn={setCustomColumn} /></TabPanel>
            <TabPanel value={value} index={3}><ScheduleMonitor loading={loading} setLoading={setLoading}
                setData={setData} setSearchKeyData={setSearchKeyData}
                setSearchData={setSearchData} customColumn={customColumn}
                searchData={searchData}
                setCustomColumn={setCustomColumn} /></TabPanel>
            {openCustomizeView && <CustomizeView setOpen={setOpenCustomizeView} customColumn={customColumn}
                setCustomColumn={setCustomColumn} />}
            {openFilters &&
                <Filters setOpen={setOpenFilters} customColumn={customColumn} setCustomColumn={setCustomColumn} />}
        </div>
    );
}

export default MonitoringIndex;
